import angular from 'angular';

import '../../services/cart';

angular.module('folkeuni').component('voucherForm', {
  bindings: {
    siteId: '@',
    programUrl: '@',
    voucher: '@'
  },
  controller: function (Cart, $timeout) {
    var $ctrl = this;
    $ctrl.errorTimer = null;

    $ctrl.validate = function () {
      $timeout.cancel($ctrl.errorTimer);
      $ctrl.errorMessage = null;

      var voucherObj = {
        password: $ctrl.voucher,
        siteId: Number($ctrl.siteId)
      }

      Cart.voucherValidate(voucherObj).then(function (successResponse) {
        var redirectUrl = $ctrl.getParameterByName('rurl');
        if (redirectUrl) {
          window.location = redirectUrl;
        } else {
          window.location = $ctrl.programUrl + "?voucher=1";
        }
      }, function (errorResponse) {

        $ctrl.errorMessage = errorResponse.data;
        $ctrl.errorTimer = $timeout(function () {
          $ctrl.errorMessage = null;
        }, 4500)
      })
    }
    $ctrl.$onInit = function () {
      if ($ctrl.voucher) {
        $ctrl.validate();
      }
    }

    $ctrl.getParameterByName = function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  },
  templateUrl: '/shop-dist/templates/voucher.html',
  transclude: false
});